<template>
  <el-dialog title="开通共享场地" :visible.sync="show" width="50%">
    <el-form>
      <el-form-item label="开通类型">
        <!-- <el-radio v-model="type" label="1">子场馆</el-radio> -->
        <el-radio v-model="type" label="2">独立空间</el-radio>
      </el-form-item>
      <el-form-item label="空间名称" v-if="type == 1">
        <el-input v-model="name" placeholder="名称"></el-input>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <auto-table
       v-if="type == 1"
        :DataList="DataList"
        :option="Option"
        :total="Total"
        @changePage="getList"
      >
        <template #handler="{ row }">
          <div>
            <i class="el-icon-check" v-if="space.id == row.id"></i>
            <el-button
              v-else
              type="primary"
              size="small"
              @click="changeSpace(row)"
              >选择</el-button
            >
          </div>
        </template>
      </auto-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="initVenue">创建</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "城市", value: "city" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
      name: "",
      show: false,
      mechanism: {},
      type: "",
      space: {},
      loading:false
    };
  },

  mounted() {},

  methods: {
    open(v) {
      this.mechanism = v;
      this.show = true;
    },
    changeSpace(v) {
      this.space = v;
    },
    initVenue() {
        if(!this.type){
            this.$message("请选择类型")
            retrun 
        }
         if(this.type == 1 && !this.space.id){
            this.$message("请选择空间")
            retrun 
        }
      this.loading = true
      let mechanism = this.mechanism;
      let path = "/shared/sharedSpace/mechanismInitSpace";
      let param = {
        space_id: this.space.id || null,
        mechanism_id: mechanism.id,
        support_means: mechanism.support_means,
        qualifications_pic: mechanism.qualifications_pic,
        logo: mechanism.mechanism_logo,
        facade_view: mechanism.facade_view,
        introduction_pic: mechanism.introduction_pic,
        name: mechanism.mechanism_name,
        telephone: mechanism.mechanism_telephone,
        contact_telephone: mechanism.contact_telephone,
        contacts: mechanism.contacts,
        categories: "体育运动",
        categories_child: mechanism.categories_child.replace(/\//g, ","),
        address: mechanism.mechanism_addr,
        longitude: mechanism.longitude,
        latitude: mechanism.latitude,
        province: mechanism.province,
        city: mechanism.city,
        district: mechanism.district,
        opentime: "周一至周日09:00-21:00",
        job_day: '1,2,3,4,5,6,7',
        type: "venue",
        operate: 3,
      };
      this.$post(path, param).then((res) => {
         this.loading = false
        this.show = false
            this.$emit('success',true)
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/sharedSpace/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: 2,
          name: this.name || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
        this.space = {}
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>